<!-- 企业 -->
<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        方案应用背景
      </p>
      <div class="content_A">
        保障企业内部信息高效流转的重要途径，将众多分支机构与企业总部以安全、高性价比的方式进行连接，从而构
        建多分支企业专有的INRANET，并保证其安全、稳定、可靠承载企业办公、管理、业务相关的诸多信息化应用
        ，成为多分支企业运营过程中的普遍性刚需。
      </div>
    </div>

    <div class="introduces  bg_color">
      <p class="sub_title">
        需求分析
      </p>
      <div class="content_A">
        <div
          v-for="item in analyses"
          :key="item.id"
          class="list"
        >
          <img
            :src="item.img"
            alt=""
          >
          <div class="purple_line" />
          <div class="list_title">
            <div
              v-for="content in item.title"
              :key="content"
            >
              {{ content }}
            </div>
          </div>
          <div class="list_content">
            <div
              v-for="list in item.list"
              :key="list"
            >
              {{ list }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="introduce">
      <div class="sub_title">
        解决方案
      </div>
      <div class="solution">
        <div class="solution_left">
          <div
            v-for="item in solutionsLeft"
            :key="item.id"
            class="solution_detail"
          >
            <div class="solution_title">
              {{ item.title }}
            </div>
            <div class="solution_content">
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="solution_img">
          <img
            src="@/assets/solution/enterprise/icon_wuranyuanchaxuntongji.png"
            alt=""
          >
        </div>
        <div class="solution_right">
          <div
            v-for="item in solutionsRight"
            :key="item.id"
            class="solution_detail"
          >
            <div class="solution_title">
              {{ item.title }}
            </div>
            <div class="solution_content">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        方案价值
      </p>
      <div class="value">
        <div
          v-for="list in values"
          :key="list.id"
          class="value_list"
        >
          <div class="img">
            <img
              :src="list.img"
              alt=""
            >
          </div>

          <div class="title">
            {{ list.title }}
          </div>
          <div class="value_content">
            {{ list.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Enterprise',
  data() {
    return {
      title: '企业多分支组网及网络安全解决方案',
      subtitle: '---企业行业应用案例',
      analyses: [
        {
          id: 1,
          img: require('@/assets/solution/enterprise/logistics-park.png'),
          title: ['总部与分支安', '全互联'],
          list: ['当前，多分支企业及', '其各分支机构基本上', '已构建了其自有的局', '域网，并普遍接入互',
            '联网，为了满足业务', '的实时交互，需要为', '多分支企业构建一个', '安全可靠、成本低廉', '的企业专网。']

        },
        {
          id: 2,
          img: require('@/assets/solution/enterprise/yard.png'),
          title: ['全面防护互联', '网威胁'],
          list: ['由于互联网的接入，', '直接影响到企业专网', '的安全性，避免用户', '在访问互联网过程中',
            '所引入的风险，需在', '业务流量进入专网前', '对流量进行深度的威', '胁检测，避免互联网', ' 威胁向专网渗透导致', '的业务系统被攻击。']

        },
        {
          id: 3,
          img: require('@/assets/solution/enterprise/shield.png'),
          title: ['内部风险的实', '时洞察'],
          list: ['企业网开放、灵活的', '特性，决定了其引入', '风险的通道较多，需', '要在做好攻击防御措',
            '施的同时，格外关注', '对内部风险的检测，', '尤其是对于企业网内', '已被攻陷或疑似失陷', '的系统，应做到及时', '发现、高效研判和尽', '早处置。']

        },
        {
          id: 4,
          img: require('@/assets/solution/enterprise/edifice.png'),
          title: ['实现全网的统', '一管理'],
          list: ['由于分支机构众多，', '地域上分布广泛，且', '缺乏专职IT安全管理', '人员，企业需要实现',
            '全网的统一监控、统', ' 一配置、统一运维，', '发现异常及时处置，', '确保各地防护强度一', '致，自动化的完成全', '网设备的升级、特征', '库更新等工作。']

        }

      ],
      solutionsLeft: [
        {
          id: 1,
          title: '构建企业VPN网络',
          content: '通过在总部和分支机构互联网边界部署智慧防火墙，并通过防火墙在总部与分支间建立IPSec VPN隧道，实现“站到站”的虚拟网络互连，构建企业VPN网络，满足各分支机构与总部的数据交互需求。'
        },
        {
          id: 2,
          title: '启用全方位攻击防护',
          content: '通过在总部及各分支机构的智慧防火墙上启用入侵防御（IPS）、病毒防护（AV）等功能，对互联网访问流量进行深度威胁检测，严防内网用户访问挂马网站、钓鱼链接的行为，在网络边界阻断恶意程序植入及远程控制通道。 '
        }
      ],
      solutionsRight: [
        {
          id: 1,
          title: '实时检测内部失陷主机',
          content: '为了进一步提升用户对网络边界威胁的感知能力，通过威胁情报对用户网络数据进行复杂逻辑的分析检测，可精准定位用户网内已被攻陷的主机，及时发现、尽早处置。'
        },
        {
          id: 2,
          title: '构建全网的集中管理平台',
          content: '通过在总部部署SMAC系统，可提供针对全网智慧防火墙的设备运行状态监控、安全配置违规核查等诸多智能化运维管理功能，构建全网的统一安全管理平台，确保全网安全的“一致性原则”切实落地。'
        }
      ],
      values: [
        {
          id: 1,
          title: '实时检测内部失陷主机',
          img: require('@/assets/solution/enterprise/a-zu98.png'),
          content: '为了进一步提升用户对网络边界威胁的感知能力，通过威胁情报对用户网络数据进行复杂逻辑的分析检测，可精准定位用户网内已被攻陷的主机，及时发现、尽早处置。'
        },
        {
          id: 2,
          title: '构建全网的集中管理平台',
          img: require('@/assets/solution/enterprise/guanwangguanli.png'),

          content: '智慧防火墙还可与“天御云”进行实时协同，持续为智慧防火墙提供病毒云查杀、恶意URL云过滤、威胁特征推送、威胁情报检测等高级功能的支撑，进一步提升智慧防火墙的威胁检出能力。 VPN隧道，实现“站到站”的虚拟网络互连，构建企业VPN网络，满足各分支机构与总部的数据交互需求。'
        },
        {
          id: 3,
          title: '基于情报的失陷主机检测',
          img: require('@/assets/solution/enterprise/ITruanjian.png'),

          content: '基于多手段的安全数据采集和深入分析，利用威胁情报与本地行为数据进行对撞的检测方式，对于发现高级威胁控制的失陷主机更具效性。通过感知能力的提升，进一步消除了安全防护的盲区。 VPN隧道，实现“站到站”的虚拟网络互连，构建企业VPN网络，满足各分支机构与总部的数据交互需求。'
        },
        {
          id: 4,
          title: '多种策略批量下发',
          img: require('@/assets/solution/enterprise/xuqiuliebiao.png'),

          content: '基于SMAC构建的集中管理平台，在满足全网监控等基本需求的同时，可实现安全策略、SSL解密策略、黑白名单、会话限制等多种安全规则的批量下发，真正实现了全网统一的安全管理。 VPN隧道，实现“站到站”的虚拟网络互连，构建企业VPN网络，满足各分支机构与总部的数据交互需求。'
        }
      ]

    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    width: 100wh;
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 80%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 80%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 50px;
      }

    }
  }

  .introduces {
    padding: 80px 0 41px 0;
    background: #FAFBFF;
  }

  .sub_title {
    margin: 79px 0 100px 0;
  }

  .content_A {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    margin-bottom: 100px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #FAFBFF;

      img {
        margin-bottom: 50px;
      }

    }

    .list_title {
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      margin: 34px 0 25px 0;
    }

    .list_content {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
    }

    .purple_line {
      width: 100%;
      height: 13px;
      background: #A8B3E9;
    }
  }

  .solution {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .solution_left {
      width: 24%;
      height: auto;

      .solution_detail {
        margin-bottom: 48px;
        height: 271px;

        .solution_title {
          font-size: 24px;
          color: #333333;
          font-weight: bold;
          text-align: end;
        }

        .solution_content {
          font-size: 18px;
          color: #333333;
          line-height: 40px;
          text-align-last: end;
        }
      }

    }

    .solution_img {
      width: 48%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .solution_right {
      width: 24%;
      height: auto;

      .solution_detail {
        margin-bottom: 48px;
        height: 271px;

        .solution_title {
          font-size: 24px;
          color: #333333;
          font-weight: bold;
          text-align: end;
        }

        .solution_content {
          font-size: 18px;
          color: #333333;
          line-height: 40px;
          text-align-last: end;
        }
      }

    }

    .bg_color {
      background-color: #FAFBFF;

    }
  }

  .value {
    width: 70%;
    margin: 0 auto;
    display: flex;
    margin-bottom: 100px;

    .value_list {
      width: 24%;
      margin-top: 30px;
      margin: 0 1%;
      background: rgba(237, 242, 253, 1);
      border-radius: 30px;
      padding: 3% 2%;
      height: 700px;
      display: flex;
      flex-direction: column;
      align-items: center;

      >.img {
        width: 100px;
        height: 100px;
        background-color: #fff;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        >img {
          width: 50%;
          height: 50%;
        }
      }

      .title {
        font-size: 24px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        margin: 17px 25px 26px;
        height: 64px;

      }

      .value_content {
        font-size: 20px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin: 0 20px;
        line-height: 30px;
        text-align-last: center
      }
    }
  }

}

@media (max-width: 750px)and (max-width: 1250px) {
  .banner .banner_Title .title {
    width: 74% !important;
  }

  .page_html .banner .banner_Title .title {
    font-size: 30px !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 37px !important;
  }

  .page_html .banner .banner_Title .subtitle,
  .page_html .content_A {
    font-size: 20px;
  }

  .page_html .content_A .list_title {
    font-size: 32px;
  }

  .page_html .content_A .list_content {
    font-size: 20px;
  }

  .banner {
    height: 400px !important;
  }

  .page_html .value .value_list .value_content {
    font-size: 14px !important;
  }

  .page_html .value .value_list .title {
    font-size: 20px !important;
  }

  .page_html .solution .solution_left .solution_detail .solution_content {
    font-size: 17px !important;
    line-height: 36px;
  }

  .page_html .solution .solution_right .solution_detail .solution_content {
    font-size: 17px;
    line-height: 36px;
  }

  .page_html .solution .solution_right .solution_detail .solution_title ,
  .page_html .solution .solution_left .solution_detail .solution_title {
    font-size: 20px;
  }

  .page_html .solution .solution_img img {
    width: 90%;
  }

  .page_html .solution,
  .value {
    width: 85% !important;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1500px) {

  .page_html .solution,
  .value {
    width: 80% !important;
  }

  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 40px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .page_html .content_A .list_title {
    font-size: 33px;
  }
  .page_html .content_A .list_content{
    font-size: 20px;
  }
  .banner {
    height: 450px !important;
  }

  .page_html .value .value_list .value_content {
    font-size: 14px !important;
  }

  .page_html .value .value_list .title {
    font-size: 20px !important;
  }

  .page_html .value .value_list .value_content {
    font-size: 14px !important;
  }

  .page_html .solution .solution_img img {
    width: 90%;
  }

  .page_html .solution .solution_left .solution_detail .solution_content {
    font-size: 17px !important;
    line-height: 36px;
  }

  .page_html .solution .solution_right .solution_detail .solution_content {
    font-size: 17px;
    line-height: 36px;
  }

  .page_html .solution .solution_right .solution_detail .solution_title {
    font-size: 20px;
  }

  .page_html .solution .solution_left .solution_detail .solution_title {
    font-size: 20px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {

  .page_html .solution,
  .value {
    width: 75% !important;
  }

  .banner .banner_Title .title {
    width: 90% !important;
    font-size: 52px !important;
  }

  .page_html .value .value_list .value_content {
    font-size: 17px !important;
  }

  .banner .banner_Title .subtitle {
    font-size: 30px !important;
  }

}
</style>
